'use strict';

var $ = window.jQuery;

window.initMap = function() {
	var mapElement = $('.js-location-map-wrapper');

	if (mapElement.length) {
		var mapStyles = [
				{
					"featureType": "administrative",
					"elementType": "all",
					"stylers": [
								{
								"hue": "#0060ff"
								},
								{
								"lightness": -100
								},
								{
								"visibility": "off"
								},
								{
								"saturation": "-77"
								}
								]
					},
					{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [
								{
								"visibility": "on"
								},
								{
								"color": "#848ea4"
								}
								]
					},
					{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
								{
								"color": "#dbe7ed"
								}
								]
					},
					{
					"featureType": "landscape",
					"elementType": "labels",
					"stylers": [
								{
								"hue": "#0060ff"
								},
								{
								"visibility": "off"
								}
								]
					},
					{
					"featureType": "poi",
					"elementType": "all",
					"stylers": [
								{
								"saturation": "-80"
								},
								{
								"lightness": "19"
								},
								{
								"visibility": "simplified"
								},
								{
								"gamma": "1"
								},
								{
								"color": "#cedbe1"
								}
								]
					},
					{
					"featureType": "poi",
					"elementType": "labels",
					"stylers": [
								{
								"visibility": "off"
								},
								{
								"color": "#cecece"
								}
								]
					},
					{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
								{
								"saturation": "-78"
								},
								{
								"lightness": "52"
								},
								{
								"visibility": "on"
								},
								{
								"color": "#ffffff"
								}
								]
					},
					{
					"featureType": "road",
					"elementType": "labels",
					"stylers": [
								{
								"saturation": "-39"
								},
								{
								"lightness": "9"
								},
								{
								"visibility": "simplified"
								},
								{
								"hue": "#00a0ff"
								}
								]
					},
					{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
								{
								"saturation": "49"
								},
								{
								"visibility": "simplified"
								}
								]
					},
					{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
								{
								"visibility": "simplified"
								},
								{
								"color": "#ffffff"
								}
								]
					},
					{
					"featureType": "road.highway",
					"elementType": "labels",
					"stylers": [
								{
								"visibility": "simplified"
								},
								{
								"hue": "#00a0ff"
								}
								]
					},
					{
					"featureType": "road.local",
					"elementType": "all",
					"stylers": [
								{
								"saturation": "0"
								},
								{
								"lightness": "0"
								},
								{
								"visibility": "simplified"
								},
								{
								"color": "#ffffff"
								},
								{
								"gamma": "1"
								}
								]
					},
					{
					"featureType": "road.local",
					"elementType": "labels",
					"stylers": [
								{
								"color": "#748088"
								},
								{
								"visibility": "simplified"
								}
								]
					},
					{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
								{
								"visibility": "simplified"
								},
								{
								"lightness": "0"
								},
								{
								"saturation": "0"
								},
								{
								"color": "#ffffff"
								}
								]
					},
					{
					"featureType": "transit",
					"elementType": "labels",
					"stylers": [
								{
								"hue": "#0060ff"
								},
								{
								"lightness": -100
								},
								{
								"visibility": "off"
								}
								]
					},
					{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
								{
								"saturation": "0"
								},
								{
								"lightness": 100
								},
								{
								"visibility": "on"
								},
								{
								"color": "#b2c7d3"
								}
								]
					},
					{
					"featureType": "water",
					"elementType": "labels",
					"stylers": [
								{
								"saturation": -100
								},
								{
								"lightness": -100
								},
								{
								"visibility": "simplified"
								},
								{
								"color": "#748088"
								}
								]
					}

		];

		var element;

		for (var i = 0; i < mapElement.length; i++) {
			element = $(mapElement[i]);

			var addressLine1 = element.data('address-line-1');
			var addressLine2 = element.data('address-line-2');
			var directions   = element.data('directions');
			var locationName = element.data('location-name');
			var lat = element.data('lat');
			var lng = element.data('lng');

			var point = new google.maps.LatLng(lat, lng);

			var mapOptions = {
				zoom: 15,
				center: point,
				mapTypeControl: false,
				panControl: true,
				scaleControl: true,
				streetViewControl: false,
				draggable: true,
				scrollwheel:  true,
				zoomControl: true,
				zoomControlOptions: {
					style: google.maps.ZoomControlStyle.LARGE,
					position: google.maps.ControlPosition.RIGHT_CENTER
				},
				styles: mapStyles
			};

			var map = new google.maps.Map(mapElement.get(i), mapOptions);

			var marker = new google.maps.Marker({
				icon: 'assets/images/design/marker.png',
				position: point,
				map: map,
				title: locationName
			});

			var contentString = '<div class="map-popup"><div class="map-popup__title">'+locationName+'</div> <div>'+addressLine1+'<br/>'+addressLine2+'</div> <a href="'+directions+'" target="_blank">Get Directions</a></div>';

			marker.infowindow = new google.maps.InfoWindow({
				content: contentString
			});

			marker.addListener('click', function() {
				this.infowindow.open(this.map, this);
			});
		}
	}
}

module.exports = window.initMap;